import React, {useState} from "react";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import TableFunction from "../../../../components/table/TableFunction";
import {permissionObj} from "../../../../Helpers/permission";
import CustomImageTable from "../../../../components/CustomImageTable";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import {colors} from "../../../../enums/colors";
import {ReactComponent as ListDetail} from "../../../../assets/images/ic-list-detail.svg";
import CustomChip from "../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import {status} from "../../../../enums/statusEnum";
import {getDeviceAccessTypeById, getIconClassesContainer} from "../../Devices/Model/Model";
import {getDeviceTypeById} from "../../../../hooks/deviceTypeEnum";
import {EMPTY_VALUES} from "../../../../Apis/functions";
import {LEFT_FIRST_COLUMN_WITH_CHECKBOX} from "../../../../components/table/Model/TableModel";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
export const DevicesTotalAccessTable =({permission,DEV,t, data, setShowLogModal})=> {
    const tableId = "tbl_ta_devices";
    const searchId = "txt_ta_devices";
    const [selectedList, setSelectedList] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [logDevice, setLogDevice] = useState(null);
    const leftPosition = LEFT_FIRST_COLUMN_WITH_CHECKBOX;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('ip')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('mac')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('s/n')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('device_type_table')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('access_type_table')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('status')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if(!data || data?.length === 0)
            return {body: [], data: [],}

        let iconClassContainer = getIconClassesContainer(data);

        let body = data.map((item) => {
            let deviceAccessType = getDeviceAccessTypeById(item?.deviceAccessType?.id);
            let deviceType = getDeviceTypeById(item?.deviceType.id);

            return (
                <> {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_DELETE) )&& (
                    <CustomTd tableId={tableId} tooltip={item?.name} fixed={true} left={leftPosition} classes={"first-column"}>{item?.name || EMPTY_VALUES.DEFAULT}</CustomTd>
                    )}
                    <CustomTd tableId={tableId} >{item?.ip || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.mac || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.serialNumber || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomImageTable
                            tooltip={t(deviceType.trans)}
                            children={<span className="text-ellipsis text-left">{t(deviceType.trans)}</span>}
                            containerClass={"d-flex"}
                            icon={<div className={`mr-2`}>{deviceType.icon && (<deviceType.icon width={30} />)}</div>}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomImageTable
                            children={<span className="text-ellipsis text-left">{t(deviceAccessType?.trans)}</span>}
                            tooltip={t(deviceAccessType?.trans)}
                            containerClass={"d-flex"}
                            icon={<div className={`${iconClassContainer} ${deviceAccessType.color} mr-2`}><deviceAccessType.Icon width={30}/></div>}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId} >
                        <CustomChip
                            background={statusColor[item?.status?.id]}
                            fontColor={statusFontColor[item?.status?.id]}
                            borderColor={statusBorderColor[item?.status?.id]}
                            legend={t(status[item?.status?.id]).toUpperCase() || EMPTY_VALUES.DEFAULT}
                            variant={"large"}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: data
        }
    };

    const getActionsButtons = (item, index) => {
        return <>
            {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_UPDATE)) && (
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`}
                >
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('LOG')}
                        click={() => {
                            const data = {
                                id: item?.id,
                                name: item?.name,
                            };

                            setLogDevice(data);
                            setShowLogModal(true);
                        }}
                        icon={<ListDetail fill={colors.dark} className='list-detail ' />}
                    />
                </DropDownMenuProfile>
            )}
        </>;
    }

    const {thead, tbody, handleCheckboxChange, handleDeleteAll, openMenu, handleMenuToggle, handleClose} = TableFunction({
        fixedPagination:false,
        selectedList:selectedList,
        setSelectedList:setSelectedList,
        isAllChecked:isAllChecked,
        setIsAllChecked:setIsAllChecked,
        data:{
            content:data,
            totalElements:data?.length
        },
        getThead,
        getTbody,
        labelRowsPerPage:"devices_per_page"
    });
    return{
        tableId1:tableId,
        searchId1:searchId,
        thead1:thead,
        tbody1:tbody,
        selectedList,
        setSelectedList,
        isAllChecked,
        logDevice,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons
    }
}
